import styled from 'styled-components';

import { COLORS, DESKTOP } from '../../../../theme/tokens';
import { Text } from '../../../../components';

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

// Read-only email: matches Field's label + inset box, but non-editable and muted,
// with a hint that it's managed by the account (auth), not editable here.
export const ReadOnly = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ReadOnlyLabel = styled(Text)`
  font-size: 14px;
  color: ${COLORS.text};
`;

export const ReadOnlyBox = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid ${COLORS.panelBorder};
  background: ${COLORS.surfaceCard};
`;

export const ReadOnlyValue = styled(Text)`
  font-size: 16px;
  color: ${COLORS.textMuted};
  word-break: break-all;
`;

export const Hint = styled(Text)`
  font-size: 12px;
  color: ${COLORS.textFaint};
`;

export const SaveError = styled(Text)`
  font-size: 13px;
  color: ${COLORS.statusDanger};
`;

/**
 * Save action — full-width on mobile; from desktop up a hairline separates it
 * from the fields and the button shrinks to half-width, centred (the `&&` doubles
 * specificity to beat the Button's own `width: 100%`). Mirrors AccountSection's Footer.
 */
export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${DESKTOP} {
    align-items: center;
    border-top: 1px solid ${COLORS.hairline};
    padding-top: 20px;

    && > * {
      width: 50%;
    }
  }
`;
